var _path, _path2, _path3, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPreferenceActiveIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.63 14.8704L15 22.5004L11.25 23.2504L12 19.5004L19.63 11.8704C20.0265 11.4732 20.5648 11.25 21.126 11.25C21.6872 11.25 22.2255 11.4732 22.622 11.8704L22.63 11.8784C23.0272 12.2749 23.2504 12.8131 23.2504 13.3744C23.2504 13.9356 23.0272 14.4738 22.63 14.8704V14.8704Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 20.25H2.25C1.42157 20.25 0.75 19.5784 0.75 18.75V2.25C0.75 1.42157 1.42157 0.75 2.25 0.75H17.25C18.0784 0.75 18.75 1.42157 18.75 2.25V9",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75 17.25H5.25C4.83579 17.25 4.5 16.9142 4.5 16.5V12.75C4.5 12.3358 4.83579 12 5.25 12H15",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 3.75,
    width: 10.5,
    height: 5.25,
    rx: 0.75,
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferenceActiveIcon);
export default __webpack_public_path__ + "static/media/preference-active-icon.bf42b9847e525811f6355ef363ecf25d.svg";
export { ForwardRef as ReactComponent };